export default __webpack_public_path__ + "static/bottom-3-c8a5ac339fb7615a6cd04536bdcf0c5a.png";